module.exports = __webpack_public_path__ + "static/canvas@2x-3b353a5ec8f5b8644df501c60ca0ecbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/wireframing/canvas@2x.jpg
// module id = 2622
// module chunks = 168707334958949